<template>
    <header class="head-nav" :style="{'background': color}">
        <el-row>
            <el-col :span="6" class='logo-container'>
                <div style="cursor:pointer" @click="collapse()">
                    <el-image :src="user.avatar" class='logo'></el-image>
                    <span class='title'>{{user.nickName}}</span>
                </div>
            </el-col>
            <el-col :span='6' class="user">
                <div>
                    <i class="screenfull el-icon-full-screen" title="全屏" @click="screenfull"></i>
                    <el-color-picker class="picker" size="medium" v-model="color" @change="themeChange"
                                     title="主题颜色"></el-color-picker>
                    <span class='username'>
                        <el-dropdown trigger="click" @command='setDialogInfo'>
                            <span class="el-dropdown-link">
                                <img :src="user.avatar" class='avatar' alt="">
                                <div class='welcome'>
                                    <p class='name comename'>欢迎, <span class="avatarname">{{user.nickName}}</span></p>
                                </div>
                                <i class="el-icon-caret-bottom el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command='info'>个人信息</el-dropdown-item>
                                <el-dropdown-item command='logout' divided>退出</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                     </span>
                </div>
            </el-col>
        </el-row>

        <el-drawer
                title="个人信息"
                :visible.sync="drawer"
                :show-close="false"
                :with-header="false">
            <div align="center">
                <img :src="user.avatar" class='avatar_big' alt="">
                <div class="userinfo">
                    <div class="user-item">
                        <i class="el-icon-user-solid"></i>
                        <span>{{user.nickName}}</span>
                    </div>
                    <div class="user-item">
                        <i class="el-icon-mobile-phone"></i>
                        <span>{{user.mobile}}</span>
                    </div>
                    <div class="user-item">
                        <i class="el-icon-chat-square"></i>
                        <span>{{user.email}}</span>
                    </div>
                </div>
            </div>
        </el-drawer>

    </header>
</template>
<script>
    import screenfull from 'screenfull'

    export default {
        name: "head-nav",
        data() {
            return {
                isFullscreen: false,
                color: this.$store.getters.theme,
                drawer: false
            }
        },
        computed: {
            user() {
                return this.$store.getters.userinfo;
            }
        },
        methods: {
            setDialogInfo(cmditem) {
                if (!cmditem) {
                    console.log("test");
                    this.$message("菜单选项缺少command属性");
                    return;
                }
                switch (cmditem) {
                    case "info":
                        this.showInfoList();
                        break;
                    case "logout":
                        this.logout();
                        break;
                }
            },
            showInfoList() {
                // 个人信息
                this.drawer = true
            },
            logout() {
                // 页面跳转
                this.$router.replace("/login");
                // 清除token
                this.removeSessionStore("accessToken");
                this.$store.dispatch("clearCurrentUserinfo");
            },
            screenfull() {
                if (!screenfull.enabled) { // 如果不允许进入全屏，发出不允许提示
                    this.$message({
                        message: '不支持全屏',
                        type: 'warning'
                    })
                    return false
                }
                screenfull.toggle()
                this.$message({
                    message: '切换全屏模式',
                    type: 'success'
                })
            },
            collapse() {
                this.$emit('result', 'collapse')
            },
            themeChange(val) {
                this.$store.commit("SET_THEME", val)
            }
        }
    };
</script>

<style lang="scss">
    .head-nav {
        width: 100%;
        height: 60px;
        min-width: 600px;
        padding: 5px;
        color: #fff;
        border-bottom: 1px solid #1f2d3d;

        .logo-container {
            line-height: 60px;
            min-width: 400px;
        }

        .logo {
            height: 50px;
            width: 50px;
            margin-right: 5px;
            vertical-align: middle;
            display: inline-block;
        }

        .title {
            vertical-align: middle;
            font-size: 22px;
            font-family: "Microsoft YaHei";
            letter-spacing: 3px;
        }

        .user {
            line-height: 60px;
            text-align: right;
            float: right;
            padding-right: 10px;
        }

        .avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            vertical-align: middle;
            display: inline-block;
        }

        .avatar_big {
            width: 220px;
            height: 220px;
        }

        .welcome {
            display: inline-block;
            width: auto;
            vertical-align: middle;
            padding: 0 5px;
        }

        .name {
            line-height: 20px;
            text-align: center;
            font-size: 14px;
        }

        .comename {
            font-size: 12px;
        }

        .avatarname {
            color: #409eff;
            font-weight: bolder;
        }

        .username {
            cursor: pointer;
            margin-right: 5px;
        }

        .screenfull {
            position: relative;
            right: 50px;
            top: 3px;
            font-size: 20px;
        }

        .picker {
            position: relative;
            right: 30px;
            top: 14px;
            font-size: 20px;
        }

        .user-item {
            position: relative;
            top: 30%;
            padding: 26px;
            font-size: 28px;
            color: #333;
        }
    }

    
</style>
